/* ===== dos hydrate — core interactions ===== */
(function () {
  'use strict';

  /* ---- Klaviyo client-side subscribe ---- */
  function normalizePhone(p) {
    var raw = (p || '').trim();
    if (!raw) return '';
    if (raw.charAt(0) === '+') return '+' + raw.slice(1).replace(/\D/g, '');
    var d = raw.replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;           // US 10-digit
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return d ? '+' + d : '';
  }
  function klaviyoPost(companyId, listId, attrs) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: attrs } },
            custom_source: 'takedos.com'
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    }).then(function (r) {
      if (r.ok) return r;
      return r.text().then(function (t) {
        var detail = t;
        try { var j = JSON.parse(t); if (j.errors && j.errors[0]) detail = (j.errors[0].detail || j.errors[0].title || t); } catch (e) {}
        console.error('[dos] Klaviyo subscribe failed', r.status, t);
        window.DOS_KLAVIYO_ERR = r.status + ': ' + String(detail).slice(0, 140);
        return r;
      });
    }).catch(function () { window.DOS_KLAVIYO_ERR = 'network error'; return { ok: false }; });
  }
  function klaviyoSubscribe(email, phone) {
    var D = window.DOS || {};
    var companyId = D.klaviyoCompanyId;
    var emailList = D.klaviyoListId;
    var smsList = D.klaviyoSmsListId || emailList;
    if (!companyId) return Promise.resolve({ skipped: true });
    var calls = [];
    if (email && emailList) {
      calls.push(klaviyoPost(companyId, emailList, { email: email }));
    }
    var e164 = normalizePhone(phone);
    if (e164 && smsList) {
      var smsAttrs = { phone_number: e164 };
      if (email) smsAttrs.email = email; // identify same profile
      calls.push(klaviyoPost(companyId, smsList, smsAttrs));
    }
    if (!calls.length) return Promise.resolve({ skipped: true });
    return Promise.all(calls).then(function (resps) {
      return { ok: resps.every(function (r) { return r && r.ok; }) };
    });
  }
  window.dosKlaviyoSubscribe = klaviyoSubscribe;
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((e || '').trim()); }
  var US_TLD = /\.(com|net|org|edu|gov|mil|us)$/i;
  function validUSPhone(p) { return /^\+1\d{10}$/.test(normalizePhone(p)); }
  // Resolves true only on a confirmed Klaviyo accept (HTTP 2xx). Missing keys / errors resolve false.
  function subscribeConfirmed(email, phone) {
    var r;
    try { r = klaviyoSubscribe(email, phone); } catch (e) { return Promise.resolve(false); }
    return Promise.resolve(r).then(function (res) {
      if (!res || res.skipped) return false;
      return !!res.ok;
    }).catch(function () { return false; });
  }

  /* ---- footer signup ---- */
  document.querySelectorAll('[data-dos-signup]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.querySelector('input[name="email"]') || {}).value || '';
      var wrap = form.parentElement;
      var done = wrap.querySelector('[data-dos-signup-done]');
      var errEl = wrap.querySelector('[data-dos-signup-error]');
      var input = form.querySelector('input[name="email"]');
      if (!validEmail(email)) {
        if (errEl) { errEl.textContent = 'Please enter a valid email address.'; errEl.style.display = 'inline-flex'; }
        if (input) { input.style.borderColor = '#ff9b9b'; input.focus(); }
        return;
      }
      if (!US_TLD.test(email.trim())) {
        if (errEl) { errEl.textContent = 'Please use an email ending in .com, .net, .org, .edu, .gov, or .us'; errEl.style.display = 'inline-flex'; }
        if (input) { input.style.borderColor = '#ff9b9b'; input.focus(); }
        return;
      }
      if (input) input.style.borderColor = '';
      var btn = form.querySelector('button[type="submit"]');
      var btnText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = '…'; }
      if (errEl) { errEl.textContent = 'Couldn’t sign you up — please try again.'; errEl.style.display = 'none'; }
      subscribeConfirmed(email.trim()).then(function (ok) {
        if (ok) {
          if (window.dosTrack) window.dosTrack('Lead', { content_name: 'footer_signup' }, { once: 'lead_footer' });
          form.style.display = 'none';
          if (done) done.style.display = 'inline-flex';
        } else {
          if (btn) { btn.disabled = false; btn.textContent = btnText; }
          if (errEl) { errEl.style.display = 'inline-flex'; }
          else { alert('Sorry — we couldn’t sign you up just now. Please try again.'); }
        }
      });
    });
  });

  /* ---- FAQ accordion (any [data-faq-item]) ---- */
  document.querySelectorAll('[data-faq-item]').forEach(function (item) {
    item.addEventListener('click', function () {
      var body = item.querySelector('[data-faq-body]');
      var chev = item.querySelector('[data-faq-chev]');
      if (!body) return;
      var open = body.style.display !== 'none';
      body.style.display = open ? 'none' : 'block';
      if (chev) chev.style.transform = open ? 'rotate(0deg)' : 'rotate(180deg)';
    });
  });

  /* ---- dark-glass pill header: menu + scroll-shrink + hero fold-size ---- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var panel = document.querySelector('[data-menu-panel]');
    var word = header.querySelector('[data-hdr-wordmark]');
    var nav = header.querySelector('nav');
    var row = header.querySelector('[data-hdr-row]');
    var hero = document.querySelector('[data-hero-sect]');
    var menuOpen = false, compact = false, lastY = 0;
    var fullWidth = function () { return Math.min(1480, (document.documentElement.clientWidth || window.innerWidth) - 36); };
    var applyPanel = function () {
      if (panel) {
        panel.style.maxHeight = menuOpen ? '440px' : '0px';
        panel.style.opacity = menuOpen ? '1' : '0';
        panel.style.margin = menuOpen ? '8px 0 6px' : '0';
        panel.style.pointerEvents = menuOpen ? 'auto' : 'none';
      }
      if (compact) header.style.width = menuOpen ? '220px' : '54px';
    };
    var setMenu = function (open) { menuOpen = open; applyPanel(); };
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-hdr-mark-btn]') || t.closest('[data-burger]')) { e.preventDefault(); setMenu(!menuOpen); }
      else if (t.closest('[data-menu-panel] a')) { setMenu(false); }
      else if (menuOpen && !t.closest('[data-site-header]')) { setMenu(false); }
    }, true);
    var sizeHero = function () {
      /* keep the header pill width in sync with the screen on resize / rotation */
      if (header) {
        if (compact) header.style.width = menuOpen ? '220px' : '54px';
        else header.style.width = fullWidth() + 'px';
      }
      /* buy module: keep the controls a constant 28px below the product images at
         every width — the fixed pull-up was tuned on a 440px screen and overlapped
         the images on smaller phones */
      var bImgcol = document.querySelector('[data-buy-imgcol]');
      var bContent = document.querySelector('[data-buy-content]');
      var bCard = document.querySelector('[data-buy-card]');
      var bIsProduct = !!document.querySelector('[data-pill-always]');
      if (bImgcol && bContent) {
        if (window.matchMedia('(max-width:760px)').matches) {
          if (bCard) { bCard.style.removeProperty('transform'); bCard.style.removeProperty('margin-bottom'); }
          if (bIsProduct) {
            /* bottle + sachet anchored to the top of their box and scaled with screen width */
            var bS = Math.max(0.72, Math.min(1, (window.innerWidth || 440) / 440));
            /* 380-400px screens (iPhone 16/15): the padding break widens the image box,
               so compensate to keep the cluster size stepping down smoothly with width */
            var bAdj = (window.innerWidth > 380 && window.innerWidth <= 400) ? 0.85 : 1;
            bImgcol.style.removeProperty('transform');
            bImgcol.style.removeProperty('transform-origin');
            /* 16 Pro and below: bottle sized to match the sachet's height exactly */
            var bBottle = bImgcol.querySelector('img[alt*="insulated" i]');
            if (bBottle) {
              /* CSS owns the bottle size (height:48% + width:auto). A percentage width
                 resolves against the auto-width gift column and collapses it to 0. */
              bBottle.style.removeProperty('width');
            }
          }
          bContent.style.setProperty('margin-top', '0px', 'important');
          var bNatTop = bContent.getBoundingClientRect().top;
          var bLow = bImgcol.getBoundingClientRect().top;
          bImgcol.querySelectorAll('img,div,span').forEach(function (el) { if (el.children.length > 0 && el.tagName !== 'IMG') return; var bb = el.getBoundingClientRect(); if (bb.height > 0 && bb.bottom > bLow) bLow = bb.bottom; });
          var bW2 = window.innerWidth || 440;
          var bGap = bIsProduct ? ((bW2 > 380 && bW2 <= 400) ? -34 : ((bW2 > 400 && bW2 <= 410) ? -18 : (bW2 <= 410 ? -30 : 4))) : 16;
          /* CSS owns the gap under the dots (see the section's mobile block) */
          bContent.style.removeProperty('margin-top');
          /* 16/15 band: slightly smaller controls */
          if (false) {
          } else {
            bContent.style.removeProperty('transform');
            bContent.style.removeProperty('transform-origin');
            bContent.style.removeProperty('margin-bottom');
          }
          /* product page: compress the whole card (title -> add to cart) until the CTA
             ends above the fold on this screen */
          if (bCard) {
            /* fold-fit safeguard removed: it scaled the card down (and shrank the
               capsule) to force Add to Cart above the fold, which broke the locked
               element widths */
            bCard.style.removeProperty('transform');
            bCard.style.removeProperty('transform-origin');
            bCard.style.removeProperty('margin-bottom');
          }
          if (false && bCard) {
            var vH = window.innerHeight;
            var bH0 = bCard.getBoundingClientRect().height; /* unscaled */
            if (vH && bH0 > 0) {
              var bFit = 1;
              /* apply, then VERIFY with a real measurement - retry tighter if the CTA
                 still lands past the fold (late fonts/images can shift metrics) */
              for (var bPass = 0; bPass < 3; bPass++) {
                var bR = bCard.getBoundingClientRect();
                var bOver = (bR.bottom + (window.pageYOffset || 0)) - (vH - 12);
                if (bOver <= 2 && bPass > 0) break;
                if (bOver <= 2 && bFit === 1) break;
                bFit = Math.max(0.66, Math.min(1, bFit * ((bR.height - bOver) / bR.height)));
                if (bFit >= 0.995) { bFit = 1; break; }
                bCard.style.setProperty('transform-origin', 'top center', 'important');
                bCard.style.setProperty('transform', 'scale(' + bFit.toFixed(3) + ')', 'important');
                bCard.style.setProperty('margin-bottom', Math.round(-bH0 * (1 - bFit) + 28) + 'px', 'important');
              }
            }
          }
        } else {
          bContent.style.removeProperty('margin-top');
          bContent.style.removeProperty('transform');
          bContent.style.removeProperty('transform-origin');
          bContent.style.removeProperty('margin-bottom');
          bImgcol.style.removeProperty('transform');
          bImgcol.style.removeProperty('transform-origin');
          if (bCard) { bCard.style.removeProperty('transform'); bCard.style.removeProperty('margin-bottom'); bCard.style.removeProperty('transform-origin'); }
        }
      }
      if (!hero) return;
      var inner = hero.querySelector('[data-hero-inner]');
      if (!window.matchMedia('(max-width:760px)').matches) {
        hero.style.removeProperty('min-height');
        if (inner) { inner.style.removeProperty('min-height'); inner.style.removeProperty('padding-top'); }
        var dChips = hero.querySelector('[data-hero-chips]');
        var dH1 = hero.querySelector('[data-hero-h1]');
        if (dChips) dChips.style.removeProperty('margin-top');
        if (dH1) dH1.style.removeProperty('transform');
        return;
      }
      var vh = window.innerHeight; if (!vh) return;
      // hero's absolute top (accounts for announcement bar + header + hero's -88 margin)
      var absTop = hero.getBoundingClientRect().top + (window.pageYOffset || 0);
      // fill to the fold + the next section's -29px overlap + a small gap,
      // so #science starts just below the fold
      var needed = Math.ceil(vh - absTop + 29 + 16);
      hero.style.setProperty('min-height', needed + 'px', 'important');
      if (inner) inner.style.setProperty('min-height', needed + 'px', 'important');
      /* The mobile hero rhythm (header clearance, chip drop, headline offset) was tuned
         on a 956px-tall screen. Scale it to the real screen so short phones (SE, mini)
         keep the same composition instead of pushing the CTA past the fold. */
      var chips = hero.querySelector('[data-hero-chips]');
      var h1 = hero.querySelector('[data-hero-h1]');
      var block = inner ? inner.firstElementChild : null;
      var isProd = !!document.querySelector('[data-pill-always]');
      var cPad = isProd ? 148 : 172, cChips = isProd ? 246 : 282, cH1 = isProd ? 110 : 166;
      var k = Math.min(1, vh / 956);
      if (inner && block && chips) {
        chips.style.setProperty('margin-top', '0px', 'important');
        inner.style.setProperty('padding-top', '0px', 'important');
        k = Math.max(0.34, Math.min(k, (vh - 12 - Math.max(0, absTop) - block.offsetHeight) / (cPad + cChips)));
      }
      if (inner) inner.style.setProperty('padding-top', Math.round(cPad * k) + 'px', 'important');
      if (chips) chips.style.setProperty('margin-top', Math.round(cChips * k) + 'px', 'important');
      if (h1) h1.style.setProperty('transform', 'translateY(' + Math.round(cH1 * k) + 'px)', 'important');
    };
    var onScroll = function () {
      var y = window.scrollY;
      if ((y - lastY) > 40 && menuOpen) setMenu(false);
      {
        var dy = y - lastY;
        var pastHero = hero
          ? (hero.getBoundingClientRect().bottom < header.getBoundingClientRect().top + 46)
          : (y > window.innerHeight * 0.9);
        var next = compact;
        if (!pastHero) next = false;
        else if (dy > 4) next = true;
        else if (dy < -4) next = false;
        if (next !== compact) {
          compact = next;
          if (compact) {
            if (menuOpen) setMenu(false);
            header.style.width = '54px';
            header.style.padding = '5px 8px';
            if (row) { row.style.justifyContent = 'center'; row.style.gap = '0px'; }
            if (word) { word.style.opacity = '0'; word.style.maxWidth = '0px'; word.style.margin = '0'; }
            if (nav) { nav.style.opacity = '0'; nav.style.maxWidth = '0px'; nav.style.overflow = 'hidden'; nav.style.pointerEvents = 'none'; }
          } else {
            header.style.width = fullWidth() + 'px';
            header.style.padding = '5px 18px';
            if (row) { row.style.justifyContent = 'space-between'; row.style.gap = '2px'; }
            if (word) { word.style.opacity = '1'; word.style.maxWidth = '140px'; word.style.margin = '0'; }
            if (nav) { nav.style.opacity = '1'; nav.style.maxWidth = ''; nav.style.overflow = ''; nav.style.pointerEvents = ''; }
          }
        }
      }
      /* sticky fabs: show after first screen, hide while buy module on screen */
      var fabs = document.querySelectorAll('[data-shop-fab],[data-promo-fab]');
      if (fabs.length) {
        var vh = window.innerHeight;
        var show = y > vh * 0.85;
        var buy = document.querySelector('#buy');
        if (buy) {
          var br = buy.getBoundingClientRect();
          if (br.top < vh * 0.92 && br.bottom > vh * 0.08) show = false;
        }
        fabs.forEach(function (fab) {
          fab.style.opacity = show ? '1' : '0';
          fab.style.pointerEvents = show ? 'auto' : 'none';
          fab.style.transform = show ? 'translateY(-100%)' : 'translateY(calc(-100% + 18px))';
        });
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('resize', sizeHero);
    sizeHero();
    setTimeout(sizeHero, 1200);
    setTimeout(sizeHero, 3000);
    setTimeout(sizeHero, 6000);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(sizeHero, 60); });
    document.querySelectorAll('[data-buy-imgcol] img').forEach(function (im) { if (!im.complete) im.addEventListener('load', sizeHero, { once: true }); });
    onScroll();
  }

  /* ---- promo questionnaire (home) ---- */
  var promo = document.querySelector('[data-promo-overlay]');
  if (promo) {
    /* the product page is where the ads land, so it tracks its own "seen" flag and
       always gets a shot at the popup; firing there also marks the site-wide flag so a
       visitor who then browses to the home page is not asked twice. */
    var isProductPage = !!document.querySelector('[data-pill-always]');
    var SEEN_KEY = isProductPage ? 'dos_promo_seen_hydrate' : 'dos_promo_seen';
    var seen = false;
    try { seen = localStorage.getItem(SEEN_KEY) === '1'; } catch (e) {}
    var state = { goal: 'Everyday hydration', freq: 'A few times a week', email: '', phone: '' };
    var openPromo = function (force) {
      if (!force && seen) return;
      seen = true;
      try { localStorage.setItem(SEEN_KEY, '1'); if (isProductPage) localStorage.setItem('dos_promo_seen', '1'); } catch (e) {}
      promo.style.display = 'flex';
      showStep('email');
    };
    window.dosOpenPromo = function () { openPromo(true); };
    var closePromo = function () { promo.style.display = 'none'; };
    /* the 20% code is only valid when this visitor actually opted into SMS */
    window.dosPromoCode = function () {
      var code = null, optin = null;
      try {
        code = localStorage.getItem('dos_discount_code');
        optin = localStorage.getItem('dos_sms_optin');
      } catch (e) {}
      if (!code) return null;
      if (code === 'TAKEDOS20' && optin !== '1') {
        code = 'DOS15';
        try { localStorage.setItem('dos_discount_code', code); } catch (e) {}
      }
      return code;
    };
    var steps = ['email', 'sms', 'done'];
    function updPromoSeg() {
      var c = window.dosPromoCode ? window.dosPromoCode() : null;
      var lbl = document.querySelector('[data-pill-promo] span');
      if (c && lbl) lbl.textContent = 'Code applied';
    }
    setTimeout(updPromoSeg, 0);
    function setPromoCode(smsOptIn) {
      var code = smsOptIn ? 'TAKEDOS20' : 'DOS15';
      try { localStorage.setItem('dos_sms_optin', smsOptIn ? '1' : '0'); } catch (e) {}
      setTimeout(updPromoSeg, 0);
      var codeEl = promo.querySelector('[data-promo-code]');
      var pctEl = promo.querySelector('[data-promo-percent]');
      if (codeEl) codeEl.textContent = code;
      if (pctEl) pctEl.textContent = smsOptIn ? '20% off' : '15% off';
      /* auto-apply the code to this session: Shopify's discount URL sets the checkout cookie */
      try { localStorage.setItem('dos_discount_code', code); } catch (e) {}
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      if (window.dosCartDiscountRefresh) window.dosCartDiscountRefresh();
    }
    var showStep = function (name) {
      steps.forEach(function (s) {
        var el = promo.querySelector('[data-promo-step="' + s + '"]');
        if (el) el.style.display = s === name ? 'flex' : 'none';
      });
      var bar = promo.querySelector('[data-promo-bar]');
      if (bar) bar.style.width = (((steps.indexOf(name) + 1) / steps.length) * 100).toFixed(0) + '%';
      var summary = promo.querySelector('[data-promo-summary]');
      if (summary) summary.textContent = state.goal;
    };
    promo.querySelectorAll('[data-promo-close]').forEach(function (b) { b.addEventListener('click', closePromo); });
    promo.querySelectorAll('[data-promo-goal]').forEach(function (b) {
      b.addEventListener('click', function () { state.goal = b.getAttribute('data-promo-goal'); showStep('email'); });
    });
    promo.querySelectorAll('[data-promo-freq]').forEach(function (b) {
      b.addEventListener('click', function () { state.freq = b.getAttribute('data-promo-freq'); showStep('q3'); });
    });
    promo.querySelectorAll('[data-promo-challenge]').forEach(function (b) {
      b.addEventListener('click', function () { state.challenge = b.getAttribute('data-promo-challenge'); showStep('email'); });
    });
    promo.querySelectorAll('[data-promo-back]').forEach(function (b) {
      b.addEventListener('click', function () { showStep(b.getAttribute('data-promo-back')); });
    });
    var emailForm = promo.querySelector('[data-promo-email-form]');
    if (emailForm) emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = (emailForm.querySelector('input') || {}).value || '';
      var inp = emailForm.querySelector('input');
      var perr = emailForm.querySelector('[data-promo-email-error]');
      if (!validEmail(val) || !US_TLD.test(val.trim())) {
        if (inp) { inp.style.borderColor = '#ff9b9b'; inp.focus(); }
        if (perr) perr.style.display = 'flex';
        return;
      }
      if (inp) inp.style.borderColor = 'transparent';
      if (perr) perr.style.display = 'none';
      state.email = val;
      var eb = emailForm.querySelector('button[type="submit"]');
      var ebText = eb ? eb.textContent : '';
      if (eb) { eb.disabled = true; eb.textContent = '…'; }
      subscribeConfirmed(state.email.trim()).then(function (ok) {
        if (eb) { eb.disabled = false; eb.textContent = ebText; }
        if (ok) {
          if (window.dosTrack) window.dosTrack('Lead', { content_name: 'promo_email' }, { once: 'lead_promo' });
          showStep('sms');
        }
        else if (perr) { perr.textContent = 'Couldn’t sign you up — please try again.'; perr.style.display = 'flex'; }
        else { alert('Sorry — we couldn’t sign you up just now. Please try again.'); }
      });
    });
    var smsForm = promo.querySelector('[data-promo-sms-form]');
    if (smsForm) smsForm.addEventListener('submit', function (e) {
      e.preventDefault();
      state.phone = (smsForm.querySelector('input') || {}).value || '';
      var sinp = smsForm.querySelector('input');
      var serr = smsForm.querySelector('[data-promo-sms-error]');
      if (!validUSPhone(state.phone)) {
        if (sinp) { sinp.style.borderColor = '#ff9b9b'; sinp.focus(); }
        if (serr) serr.style.display = 'flex';
        return;
      }
      if (sinp) sinp.style.borderColor = 'transparent';
      if (serr) serr.style.display = 'none';
      var sb = smsForm.querySelector('button[type="submit"]');
      var sbText = sb ? sb.textContent : '';
      if (sb) { sb.disabled = true; sb.textContent = '…'; }
      // SMS is a bonus — email is already captured. Best-effort add phone, never block completion.
      subscribeConfirmed(state.email.trim(), state.phone.trim()).then(function () {
        if (window.dosTrack) window.dosTrack('Subscribe', { content_name: 'promo_sms' }, { once: 'sub_promo_sms' });
        if (sb) { sb.disabled = false; sb.textContent = sbText; }
        setPromoCode(true);
        showStep('done');
      });
    });
    var skipSms = promo.querySelector('[data-promo-skip-sms]');
    if (skipSms) skipSms.addEventListener('click', function () {
      // Email already captured at the email step — just finish.
      setPromoCode(false);
      showStep('done');
    });
    if (!seen) {
      setTimeout(function () { openPromo(); }, 20000);
      var scrollTrig = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= 0.6) { openPromo(); window.removeEventListener('scroll', scrollTrig); }
      };
      window.addEventListener('scroll', scrollTrig, { passive: true });
      document.addEventListener('mouseout', function exitTrig(e) {
        if (e.clientY <= 0 && !e.relatedTarget) { openPromo(); document.removeEventListener('mouseout', exitTrig); }
      });
    }
    var promoFab = document.querySelector('[data-promo-fab]');
    if (promoFab) promoFab.addEventListener('click', function () { openPromo(true); });
  }

  /* ---- tinted-glass cart drawer + sticky pill ---- */
  (function () {
    var overlay = document.querySelector('[data-cart-overlay]');
    var pill = document.querySelector('[data-cart-pill]');
    if (!overlay || !pill) return;
    var itemsEl = overlay.querySelector('[data-cart-items]');
    var emptyEl = overlay.querySelector('[data-cart-empty]');
    var footerEl = overlay.querySelector('[data-cart-footer]');
    var countEl = overlay.querySelector('[data-cart-count]');
    var totalEl = overlay.querySelector('[data-cart-total]');
    var pillLabel = pill.querySelector('[data-cart-pill-label]');
    var segPromo = pill.querySelector('[data-pill-promo]');
    var segCart = pill.querySelector('[data-pill-cart]');
    var segShop = pill.querySelector('[data-pill-shop]');
    /* on buy pages the pill's last segment is a real Add to Cart, not a scroll link */
    if (segShop) segShop.addEventListener('click', function (e) {
      var cta = document.querySelector('[data-buy-checkout]');
      if (cta) { e.preventDefault(); cta.click(); }
    });
    var div1 = pill.querySelector('[data-pill-div1]');
    var div2 = pill.querySelector('[data-pill-div2]');
    var inRange = false;
    var cart = null;
    var isOpen = false;
    var busy = false;

    function money(cents) {
      var d = cents / 100;
      return '$' + (d % 1 === 0 ? d : d.toFixed(2));
    }
    function isGift(item) { return !!(item.properties && item.properties._dos_free_gift); }

    function el(tag, style, text) {
      var n = document.createElement(tag);
      if (style) n.style.cssText = style;
      if (text != null) n.textContent = text;
      return n;
    }

    /* Cart copy normaliser, shared by the drawer and the cart page.
       - the bottle reads "Hydrate Bottle" and 500 ml (never 24 oz)
       - the sachet's comma-separated details each get their own line */
    function dosCartFixUnits(s) {
      return String(s || '')
        .replace(/\b24\s*(?:fl\.?\s*)?oz\b\.?/gi, '500 ml')
        .replace(/\b500\s*ml\b/gi, '500 ml')
        .replace(/\bsticks?\b/gi, 'sachets');
    }
    var DOS_PINK = '#D4568A';
    function isPackCount(s) {
      var t = String(s || '').trim();
      /* "1 pack", "3 Packs", "pack x2", "2-pack", "one pack" — but never "Variety pack" */
      if (/variety/i.test(t)) return false;
      return /^(?:\d+|one|two|three|a)\s*[-–]?\s*packs?$/i.test(t) || /^packs?\s*[x×]?\s*\d+$/i.test(t);
    }
    function dosCartTitle(item) {
      /* Titles arrive in whatever shape the Shopify product uses
         ("dos HYDRATE - - 1 Pack (30 sachets)"), so derive the fields
         instead of trying to parse the format. */
      var raw = dosCartFixUnits(item.product_title || '');
      var variant = dosCartFixUnits(item.variant_title || '');
      var hay = raw + ' ' + variant;
      var isBottle = /bottle/i.test(hay) || isGift(item);
      if (isBottle) {
        /* the free gift doesn't need two spec lines in a tight drawer */
        return isGift(item)
          ? { title: 'dos Hydrate Bottle', details: [{ t: '500 ml', style: 'dim' }], compact: true }
          : { title: 'dos Hydrate Bottle', details: [
              { t: 'Stainless steel', style: 'dim' },
              { t: '500 ml', style: 'dim' }
            ] };
      }
      var details = [];
      var m = hay.match(/(\d+)\s*sachets?/i);
      if (!m) {
        /* fall back to the pack count when the sachet total is absent */
        var pm = hay.match(/(\d+)\s*[-–]?\s*packs?/i);
        if (pm) m = [null, String(parseInt(pm[1], 10) * 30)];
      }
      if (m) details.push({ t: m[1] + ' sachets', style: 'dim' });
      /* one row per chosen box, so a 2- or 3-pack lists its flavours separately */
      var boxes = Object.keys(item.properties || {})
        .filter(function (k) { return /^Flavor \d+$/.test(k); })
        .sort(function (a, b) { return parseInt(a.slice(7), 10) - parseInt(b.slice(7), 10); });
      if (boxes.length) {
        boxes.forEach(function (k) { details.push({ t: k + ': ' + item.properties[k], style: 'pink', flavor: item.properties[k] }); });
      } else if (item.properties && item.properties['Flavor']) {
        details.push({ t: item.properties['Flavor'], style: 'pink', flavor: item.properties['Flavor'] });
      } else {
        var fl = hay.match(/pink lemonade|variety pack/i);
        if (fl) details.push({ t: fl[0].replace(/\b\w/g, function (c) { return c.toUpperCase(); }), style: 'pink' });
      }
      var sp = item.selling_plan_allocation && (item.selling_plan_allocation.selling_plan || item.selling_plan_allocation.selling_plan_group_id);
      return { title: 'dos Hydrate', details: details };
    }

    /* flavour -> swatch colour + pack art, so a cart line matches what was picked */
    function flavorEntry(name) {
      var list = window.DOS_FLAVORS || [];
      if (!name) return null;
      var key = String(name).toLowerCase();
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].name).toLowerCase() === key) return list[i];
      }
      return null;
    }
    function flavorColor(name) { var f = flavorEntry(name); return f && f.color; }
    function flavorArt(currentSrc, name) {
      var f = flavorEntry(name);
      if (!f || !f.img || !currentSrc) return null;
      var base = String(currentSrc).replace(/pack-[a-z-]+\.png.*$/, '');
      return base === currentSrc ? null : base + f.img;
    }

    function renderItem(item, line) {
      var row = el('div', 'display:flex;gap:12px;align-items:center;background:rgba(255,255,255,0.7);border:1px solid rgba(255,255,255,0.8);border-radius:16px;padding:12px 14px');
      var lineFlavor = (item.properties && (item.properties['Flavor'] || item.properties['Flavor 1'])) || null;
      if (item.image) {
        var img = document.createElement('img');
        img.src = flavorArt(item.image, lineFlavor) || item.image;
        img.alt = item.product_title || '';
        img.style.cssText = 'width:52px;height:52px;object-fit:contain;border-radius:10px;background:#F7F7F7;flex:none';
        row.appendChild(img);
      }
      var info = el('div', 'flex:1;min-width:0');
      var t = dosCartTitle(item);
      info.appendChild(el('div', 'font-size:13.5px;font-weight:800;color:#171717;line-height:1.3', t.title));
      /* every detail on its own line so nothing truncates */
      t.details.forEach(function (d) {
        var tint = d.flavor ? flavorColor(d.flavor) : null;
        var style = d.style === 'pink'
          ? 'font-size:11px;font-weight:800;color:' + (tint || DOS_PINK) + ';line-height:1.4'
          : 'font-size:11px;font-weight:600;color:#171717;opacity:0.6;line-height:1.4';
        info.appendChild(el('div', style, d.t));
      });
      if (isGift(item)) info.appendChild(el('div', 'display:inline-block;background:#D6E594;color:#171717;font-size:9px;font-weight:900;letter-spacing:0.09em;text-transform:uppercase;padding:2px 8px;border-radius:100px;margin-top:5px', 'Free gift'));
      row.appendChild(info);
      if (!isGift(item)) {
        var step = el('div', 'display:flex;align-items:center;background:rgba(23,23,23,0.05);border-radius:100px;flex:none');
        var minus = el('button', 'border:none;background:transparent;cursor:pointer;width:30px;height:32px;font-size:16px;font-weight:800;color:#171717;font-family:inherit;line-height:1', '\u2212');
        var qty = el('span', 'min-width:20px;text-align:center;font-size:13px;font-weight:800;color:#171717', String(item.quantity));
        var plus = el('button', 'border:none;background:transparent;cursor:pointer;width:30px;height:32px;font-size:16px;font-weight:800;color:#171717;font-family:inherit;line-height:1', '+');
        minus.setAttribute('aria-label', 'Decrease quantity');
        plus.setAttribute('aria-label', 'Increase quantity');
        minus.addEventListener('click', function () { change(line, item.quantity - 1); });
        plus.addEventListener('click', function () { change(line, item.quantity + 1); });
        step.appendChild(minus); step.appendChild(qty); step.appendChild(plus);
        row.appendChild(step);
      }
      row.appendChild(el('div', 'font-size:13.5px;font-weight:800;color:#171717;min-width:52px;text-align:right;flex:none', isGift(item) ? 'FREE' : money(item.final_line_price)));
      return row;
    }


    /* One block for several flavour lines of the same product: combined sachet
       count and price, a chip per flavour (tinted to match the picker), and a
       single remove control that clears the whole group. */
    function renderFlavorGroup(g) {
      var row = el("div", "display:flex;gap:12px;align-items:flex-start;background:rgba(255,255,255,0.55);border:1px solid rgba(255,255,255,0.7);border-radius:18px;padding:10px 12px");
      var first = g.items[0];
      var totalQty = 0, totalCents = 0, sachets = 0;
      g.items.forEach(function (it) {
        totalQty += it.quantity;
        totalCents += it.final_line_price;
        var m = String(it.product_title + " " + (it.variant_title || "")).match(/(\d+)\s*sachets?/i);
        sachets += (m ? parseInt(m[1], 10) : 30) * it.quantity;
      });
      if (first.image) {
        var img = document.createElement("img");
        img.src = flavorArt(first.image, (first.properties || {})["Flavor"]) || first.image;
        img.alt = "";
        img.style.cssText = "width:52px;height:52px;flex:none;object-fit:contain;border-radius:12px;background:rgba(23,23,23,0.04)";
        row.appendChild(img);
      }
      var info = el("div", "flex:1;min-width:0");
      info.appendChild(el("div", "font-size:13px;font-weight:900;letter-spacing:-0.01em;color:#171717", "dos Hydrate"));
      info.appendChild(el("div", "font-size:11px;font-weight:600;color:#171717;opacity:0.6;line-height:1.4", sachets + " sachets"));
      var chips = el("div", "display:flex;flex-wrap:wrap;gap:5px;margin-top:6px");
      g.items.forEach(function (it) {
        var nm = (it.properties || {})["Flavor"];
        var tint = flavorColor(nm) || DOS_PINK;
        var c = el("span", "display:inline-flex;align-items:center;gap:5px;font-size:10.5px;font-weight:800;letter-spacing:0.02em;color:#171717;background:" + tint + "24;border:1px solid " + tint + "55;padding:3px 8px;border-radius:100px");
        var isVariety = /variety/i.test(String(nm || ""));
        var dot = el("span", "width:7px;height:7px;border-radius:50%;flex:none;background:" + (isVariety ? "conic-gradient(#CB7D98,#E89191,#F3AF96,#DB4D2E,#C3D187,#5E8C3A,#CB7D98)" : tint));
        c.appendChild(dot);
        c.appendChild(document.createTextNode(nm + (it.quantity > 1 ? " x" + it.quantity : "")));
        chips.appendChild(c);
      });
      info.appendChild(chips);
      row.appendChild(info);
      var right = el("div", "display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex:none");
      right.appendChild(el("div", "font-size:13px;font-weight:900;color:#171717", money(totalCents)));
      var rm = document.createElement("button");
      rm.type = "button";
      rm.textContent = "Remove";
      rm.style.cssText = "border:none;background:transparent;cursor:pointer;font-family:inherit;font-size:10.5px;font-weight:700;color:#171717;opacity:0.5;padding:0";
      rm.addEventListener("click", function () {
        /* removing from the end keeps the earlier line numbers valid */
        var lines = g.lines.slice().sort(function (a, b) { return b - a; });
        var chain = Promise.resolve();
        lines.forEach(function (ln) {
          chain = chain.then(function () {
            return fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ line: ln, quantity: 0 })
            }).then(function (r) { return r.json(); });
          });
        });
        chain.then(function (c) { cart = c; render(); }).catch(function () {});
      });
      right.appendChild(rm);
      row.appendChild(right);
      return row;
    }

    function render() {
      if (!cart) return;
      var items = cart.items || [];
      itemsEl.innerHTML = '';
      /* Flavour picks are separate cart lines of the SAME product, which read as
         three near-identical rows. Collapse them into one block: product name,
         combined sachet count and price, with a chip per flavour. */
      var groups = [], byVariantBase = {};
      items.forEach(function (item, i) {
        var line = i + 1;
        var fl = (item.properties || {})['Flavor'];
        if (!fl || isGift(item)) { groups.push({ single: item, line: line }); return; }
        var key = String(item.product_title || '') + '|' + (item.selling_plan_allocation ? 'sub' : 'once');
        if (!byVariantBase[key]) {
          byVariantBase[key] = { items: [], lines: [], key: key };
          groups.push(byVariantBase[key]);
        }
        byVariantBase[key].items.push(item);
        byVariantBase[key].lines.push(line);
      });
      groups.forEach(function (g) {
        if (g.single) { itemsEl.appendChild(renderItem(g.single, g.line)); return; }
        if (g.items.length === 1) { itemsEl.appendChild(renderItem(g.items[0], g.lines[0])); return; }
        itemsEl.appendChild(renderFlavorGroup(g));
      });
      var has = items.length > 0;
      itemsEl.style.display = has ? 'flex' : 'none';
      emptyEl.style.display = has ? 'none' : 'flex';
      footerEl.style.display = has ? 'block' : 'none';
      var count = items.reduce(function (n, it) { return n + (isGift(it) ? 0 : it.quantity); }, 0);
      countEl.textContent = String(count);
      totalEl.textContent = money(cart.total_price);
      pillLabel.textContent = count > 0 ? (count + (count === 1 ? ' item' : ' items') + ' \u00b7 ' + money(cart.total_price)) : '';
      pillLabel.style.display = count > 0 ? '' : 'none';
      /* a cart change can reveal the pill above the fold, so re-run visibility too */
      if (typeof updRange === 'function') updRange();
      updatePill();
    }

    function updatePill() {
      /* one segment at a time: the green Add button until the cart holds an item, then
         the cart takes its place. No 15% off segment. */
      var cartCount = cart ? cart.items.reduce(function (n, it) { return n + (isGift(it) ? 0 : it.quantity); }, 0) : 0;
      var expanded = pastFold || cartCount > 0;
      var cartVis = cartCount > 0;
      var promoVis = false;
      var shopVis = !!segShop && expanded && cartCount === 0;
      /* setProperty with priority: the segment CSS uses !important for colour and
         sizing, so a plain inline display could be outranked */
      var show = function (el, on, mode) {
        if (el) el.style.setProperty('display', on ? (mode || 'inline-flex') : 'none', 'important');
      };
      show(segCart, cartVis);
      show(segPromo, promoVis);
      show(segShop, shopVis);
      show(div1, promoVis && (cartVis || shopVis), 'block');
      show(div2, shopVis && cartVis, 'block');
      pill.classList.toggle('show', !isOpen && inRange && (promoVis || cartVis || shopVis));
    }

    /* pill visibility: always on for the shop page; elsewhere it rides from just
       past the header until the footer arrives */
    var alwaysOnPill = document.querySelector('[data-pill-always]') !== null;
    var pastFold = false;
    var updRange = function () {
      if (alwaysOnPill) {
        var pf = window.scrollY > (window.innerHeight * 0.9);
        var hasItems = cart && cart.items.some(function (it) { return !isGift(it); });
        var vis = pf || !!hasItems;
        if (pf !== pastFold) { pastFold = pf; updatePill(); }
        if (vis !== inRange) { inRange = vis; updatePill(); }
        return;
      }
      var vh = window.innerHeight;
      var pf2 = window.scrollY > (vh * 0.9);
      if (pf2 !== pastFold) { pastFold = pf2; }
      var hasItems2 = cart && cart.items.some(function (it) { return !isGift(it); });
      var show = pf2 || !!hasItems2;
      var foot = document.querySelector('[data-site-footer]') || document.querySelector('footer');
      if (foot) {
        var fr = foot.getBoundingClientRect();
        if (fr.top < vh - 40) show = false;
      }
      if (show !== inRange) { inRange = show; updatePill(); }
    };
    window.addEventListener('scroll', updRange, { passive: true });
    window.addEventListener('resize', updRange);
    updRange();

    /* free-gift housekeeping: no subscription left -> drop the gift */
    function housekeeping(c) {
      var items = c.items || [];
      var hasSub = items.some(function (it) { return !!it.selling_plan_allocation; });
      var giftIdx = -1;
      items.forEach(function (it, i) { if (isGift(it)) giftIdx = i; });
      if (giftIdx >= 0 && !hasSub) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: giftIdx + 1, quantity: 0 })
        }).then(function (r) { return r.json(); });
      }
      return Promise.resolve(c);
    }

    function refresh() {
      return fetch('/cart.js').then(function (r) { return r.json(); })
        .then(housekeeping)
        .then(function (c) { cart = c; render(); return c; })
        .catch(function () {});
    }

    function change(line, quantity) {
      if (busy) return;
      busy = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
      }).then(function (r) { return r.json(); })
        .then(housekeeping)
        .then(function (c) { busy = false; cart = c; render(); })
        .catch(function () { busy = false; });
    }

    function open() {
      isOpen = true;
      overlay.classList.remove('to-pill');
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      updatePill();
      refresh();
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      overlay.classList.add('to-pill');
      overlay.setAttribute('aria-hidden', 'true');
      updatePill();
      setTimeout(function () {
        overlay.classList.remove('open');
        overlay.classList.remove('to-pill');
      }, 380);
    }

    overlay.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.querySelector('[data-cart-scrim]').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (segCart) segCart.addEventListener('click', open);
    if (segPromo) segPromo.addEventListener('click', function () { if (window.dosOpenPromo) window.dosOpenPromo(); });
    var checkoutBtn = overlay.querySelector('[data-cart-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () {
      if (window.dosTrack) window.dosTrack('InitiateCheckout', {});
      var code = window.dosPromoCode ? window.dosPromoCode() : null;
      window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout' : '/checkout';
    });

    /* promo code chip in the drawer */
    var discEl = overlay.querySelector('[data-cart-discount]');
    var discCodeEl = overlay.querySelector('[data-cart-discount-code]');
    function updDiscount() {
      var nud = document.querySelector('[data-cart-subnudge]');
      if (nud) {
        var hasOnce = false;
        try { hasOnce = !!(typeof cart !== 'undefined' && cart && cart.items && cart.items.some(function (it) { return !isGift(it) && !it.selling_plan_allocation; })); } catch (e) {}
        nud.style.display = hasOnce ? 'flex' : 'none';
      }
      if (!discEl) return;
      var code = window.dosPromoCode ? window.dosPromoCode() : null;
      if (code && discCodeEl) discCodeEl.textContent = code;
      discEl.style.display = code ? 'flex' : 'none';
    }
    var nudBtn = document.querySelector('[data-cart-subnudge]');
    if (nudBtn && !nudBtn.__dosSwitch) {
      nudBtn.__dosSwitch = true;
      nudBtn.addEventListener('click', function () {
        var packs = (window.DOS_BUY && window.DOS_BUY.packs) || [];
        var planFor = {};
        packs.forEach(function (p) { if (p && p.variant && p.sellingPlan) planFor[p.variant] = p.sellingPlan; });
        nudBtn.style.opacity = '0.55';
        /* one line at a time, re-reading the cart between changes (Shopify may merge lines) */
        function step(n) {
          if (n <= 0) return Promise.resolve();
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var items = c.items || [];
            for (var i = 0; i < items.length; i++) {
              var it = items[i];
              if (!isGift(it) && !it.selling_plan_allocation && planFor[it.variant_id]) {
                return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ line: i + 1, quantity: it.quantity, selling_plan: planFor[it.variant_id] }) })
                  .then(function () { return step(n - 1); });
              }
            }
            return null;
          });
        }
        step(5).then(function () {
          /* free bottle joins the newly subscribed cart if it isn't there */
          var g = window.DOS_BUY && window.DOS_BUY.gift;
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            var items = c.items || [];
            var hasSub = items.some(function (it) { return !!it.selling_plan_allocation; });
            var hasGift = items.some(isGift);
            if (hasSub && !hasGift && g && g.variant) {
              return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: g.variant, quantity: 1, properties: { _dos_free_gift: '1' } }] }) });
            }
            return null;
          });
        }).then(function () { nudBtn.style.opacity = ''; return refresh(); })
          .catch(function () { nudBtn.style.opacity = ''; refresh(); });
      });
    }
    window.dosCartDiscountRefresh = updDiscount;
    updDiscount();

    /* header cart icon opens the drawer instead of navigating */
    var cartUrl = (window.DOS && window.DOS.cartUrl) || '/cart';
    document.querySelectorAll('a[href="' + cartUrl + '"]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });

    window.dosCart = { open: open, close: close, refresh: refresh };
    refresh();
  })();
})();

/* ===== announcement sale timer: counts down to midnight local, resets daily ===== */
(function () {
  var el = document.querySelector('[data-sale-timer]');
  if (!el) return;
  var p2 = function (x) { return ('0' + x).slice(-2); };
  var tick = function () {
    var end = new Date(); end.setHours(23, 59, 59, 999);
    var rem = Math.max(0, end - Date.now());
    el.textContent = p2(Math.floor(rem / 3600000)) + ':' + p2(Math.floor(rem / 60000) % 60) + ':' + p2(Math.floor(rem / 1000) % 60);
  };
  tick(); setInterval(tick, 1000);
})();

/* ===== product-page capsule: swipe carousel dots + product cluster fit ===== */
(function () {
  'use strict';
  function init() {
    var cap = document.querySelector('[data-buy-capsule]');
    if (!cap) return;
    var col = cap.closest('[data-buy-imgcol]') || document;
    var track = cap.querySelector('[data-buy-carousel]');
    var dots = col.querySelector('[data-buy-dots]');

    /* dots follow the scroll position */
    if (track && dots) {
      var sync = function () {
        var i = Math.max(0, Math.min(dots.children.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
        for (var d = 0; d < dots.children.length; d++) {
          var el = dots.children[d];
          el.style.opacity = d === i ? '1' : '0.45';
          el.style.boxShadow = d === i ? '0 0 0 2px #171717' : '0 0 0 1px rgba(23,23,23,0.12)';
        }
      };
      track.addEventListener('scroll', sync, { passive: true });
      dots.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('[data-buy-thumb]');
        if (!btn) return;
        track.scrollTo({ left: track.clientWidth * Number(btn.getAttribute('data-buy-thumb')), behavior: 'smooth' });
      });
      sync();
    }

    /* fit the sachet + bottle to the capsule: sachet spans 25%-75%,
       bottle keeps its top on 25% and reaches 79% */
    var fit = function () {
      var sEl = null, imgs = cap.querySelectorAll('[data-buy-pack-desktop],[data-buy-pack-mobile]');
      for (var i = 0; i < imgs.length; i++) {
        if (getComputedStyle(imgs[i]).display !== 'none') { sEl = imgs[i]; break; }
      }
      var bEl = null, all = cap.querySelectorAll('img');
      for (var j = 0; j < all.length; j++) {
        if (all[j].hasAttribute('data-buy-alt-slide')) continue;
        if (/insulated/i.test(all[j].getAttribute('alt') || '')) { bEl = all[j]; break; }
      }
      if (!sEl || !bEl || !sEl.naturalWidth || !bEl.naturalWidth) return;
      return; /* cluster fit is CSS-owned at every width (zoom-proof) */
      /* eslint-disable no-unreachable */
      var TOP = 0.25, BOT = 0.79, p, r, dy;
      /* the bottle's width % resolves against its own narrow column, and the sachet
         inherits a max-height — clear both so the fit loops can reach the target */
      [sEl, bEl].forEach(function (el) {
        el.style.setProperty('max-width', 'none', 'important');
        el.style.setProperty('max-height', 'none', 'important');
        if (el.parentElement) {
          el.parentElement.style.setProperty('max-width', 'none', 'important');
          el.parentElement.style.setProperty('overflow', 'visible', 'important');
        }
      });
      /* pixel height, not width % — the gift column is a fixed 124px so a
         percentage width can never reach the target */
      bEl.style.setProperty('width', 'auto', 'important');
      for (p = 0; p < 10; p++) {
        var cR = cap.getBoundingClientRect();
        var wantB = cR.height * (BOT - TOP);
        var bh = bEl.getBoundingClientRect().height;
        if (!wantB || !bh || Math.abs(bh - wantB) < 1) break;
        bEl.style.setProperty('height', ((parseFloat(bEl.style.height) || bh) * wantB / bh).toFixed(1) + 'px', 'important');
      }
      for (p = 0; p < 10; p++) {
        var cR2 = cap.getBoundingClientRect();
        var wantS = cR2.height * 0.5;
        var sh = sEl.getBoundingClientRect().height;
        if (!sh || !wantS || Math.abs(sh - wantS) < 1) break;
        sEl.style.setProperty('height', ((parseFloat(sEl.style.height) || sh) * wantS / sh).toFixed(1) + 'px', 'important');
      }
      var cR3 = cap.getBoundingClientRect();
      for (p = 0; p < 3; p++) {
        r = sEl.getBoundingClientRect();
        dy = Math.round((cR3.top + cR3.height / 2) - (r.top + r.height / 2));
        if (!dy) break;
        sEl.style.setProperty('margin-top', ((parseFloat(sEl.style.marginTop) || 0) + dy) + 'px', 'important');
      }
      for (p = 0; p < 3; p++) {
        r = bEl.getBoundingClientRect();
        dy = Math.round((cR3.top + cR3.height * TOP) - r.top);
        if (!dy) break;
        bEl.style.setProperty('margin-top', ((parseFloat(bEl.style.marginTop) || 0) + dy) + 'px', 'important');
      }
      /* horizontal: sachet centred on the 25% guide, bottle on the 75% guide */
      [[sEl, 0.25], [bEl, 0.75]].forEach(function (pair) {
        var el = pair[0], at = pair[1], w2 = el && el.parentElement;
        if (!w2) return;
        w2.style.removeProperty('transform');
        for (var q = 0; q < 3; q++) {
          var cc = cap.getBoundingClientRect(), rr = el.getBoundingClientRect();
          var dx = Math.round((cc.left + cc.width * at) - (rr.left + rr.width / 2));
          if (!dx) break;
          var m = (w2.style.transform || '').match(/translateX\((-?[\d.]+)px\)/);
          w2.style.setProperty('transform', 'translateX(' + ((m ? parseFloat(m[1]) : 0) + dx) + 'px)', 'important');
        }
      });
      /* ×30 mark sits level with the "Insulated bottle" caption */
      var multEl = cap.querySelector('[data-buy-mult]');
      var captEl = bEl.parentElement && (function () {
        var kids = bEl.parentElement.children;
        for (var k = 0; k < kids.length; k++) {
          if (kids[k].tagName === 'DIV' && /Insulated bottle/i.test(kids[k].textContent)) return kids[k];
        }
        return null;
      })();
      if (multEl && captEl) {
        multEl.style.setProperty('bottom', 'auto', 'important');
        if (!multEl.style.top) multEl.style.setProperty('top', '0px', 'important');
        for (var t2 = 0; t2 < 3; t2++) {
          var mr = multEl.getBoundingClientRect(), cr2 = captEl.getBoundingClientRect();
          var dy2 = Math.round((cr2.top + cr2.height / 2) - (mr.top + mr.height / 2));
          if (!dy2) break;
          multEl.style.setProperty('top', ((parseFloat(multEl.style.top) || 0) + dy2) + 'px', 'important');
        }
      }
      /* 2/3-pack stack copies match the front sachet exactly */
      var wrap = sEl.parentElement;
      if (wrap) {
        var sH = parseFloat(sEl.style.height) || sEl.getBoundingClientRect().height;
        wrap.querySelectorAll('img[aria-hidden="true"]').forEach(function (cp) {
          if (getComputedStyle(cp).display === 'none') return;
          if (sH) cp.style.setProperty('height', sH + 'px', 'important');
          for (var q = 0; q < 3; q++) {
            var d2 = Math.round(sEl.getBoundingClientRect().top - cp.getBoundingClientRect().top);
            if (!d2) break;
            cp.style.setProperty('top', ((parseFloat(cp.style.top) || 0) + d2) + 'px', 'important');
          }
        });
      }
    };

    /* normalize the capsule: 12px (1/8in) gutter each side of the page, matched
       height ratio. The buy card is CSS-scaled, so divide that (and any browser
       zoom) back out before setting the css box. */
    var sizeCapsule = function () {
      /* mobile is handled entirely by CSS (see the section's max-width:760px block) —
         measuring here fought the scaled wrapper and caused jitter */
      return; /* geometry is CSS-owned at every width (zoom-proof) */
      /* eslint-disable no-unreachable */
      var RATIO = 414 / 330;
      var docW = document.documentElement.clientWidth || window.innerWidth || 390;
      var colW = docW > 760 ? ((col.getBoundingClientRect && col.getBoundingClientRect().width) || 9999) : 9999;
      var target = Math.max(180, Math.min(docW - 24, colW));
      /* the stack column / image column are narrower than the target, which clamps
         the capsule — let them grow first */
      var stack = cap.parentElement;
      if (stack && stack.style) {
        stack.style.setProperty('width', target.toFixed(1) + 'px', 'important');
        stack.style.setProperty('max-width', 'none', 'important');
      }
      if (col && col.style && docW <= 760) {
        col.style.setProperty('overflow', 'visible', 'important');
        col.style.setProperty('max-width', 'none', 'important');
        col.style.setProperty('width', 'auto', 'important');
      }
      for (var p = 0; p < 8; p++) {
        var r = cap.getBoundingClientRect();
        var cssW = cap.offsetWidth;
        if (!cssW || !r.width) break;
        var scale = r.width / cssW;
        if (!scale) break;
        var want = target / scale;
        if (Math.abs(want - cssW) < 1) break;
        /* CSS owns the capsule box (width:100% + aspect-ratio:1/1) */
        break;
      }
      /* the controls below are capped at 340px in CSS — widen them to the capsule so
         the card reads as one column */
      var content = document.querySelector('[data-buy-content]');
      if (content && docW <= 760) {
        var capCss = parseFloat(cap.style.width) || cap.offsetWidth;
        if (capCss) {
          /* the pill, plan toggle, pack row, CTA and trust line are the content
             column's direct children — widen them all to the capsule */
          var kids = content.children;
          for (var k = 0; k < kids.length; k++) {
            var kid = kids[k];
            if (!kid.style) continue;
            kid.style.setProperty('max-width', capCss.toFixed(1) + 'px', 'important');
            kid.style.setProperty('margin-left', 'auto', 'important');
            kid.style.setProperty('margin-right', 'auto', 'important');
            kid.style.setProperty('box-sizing', 'border-box', 'important');
          }
          content.style.setProperty('max-width', capCss.toFixed(1) + 'px', 'important');
          content.style.setProperty('margin-left', 'auto', 'important');
          content.style.setProperty('margin-right', 'auto', 'important');
        }
      }
    };
    /* jitter guards: ignore resize events that don't change the page width (mobile
       browsers fire them while the URL bar collapses) and ignore the ResizeObserver
       ticks caused by our own writes */
    var lastW = 0, selfWrite = false;
    var sizeAndFit = function (force) {
      var w = document.documentElement.clientWidth || window.innerWidth || 0;
      if (!force && w === lastW) return;
      lastW = w;
      selfWrite = true;
      sizeCapsule();
      fit();
      setTimeout(function () { selfWrite = false; }, 120);
    };

    sizeAndFit(true);
    cap.querySelectorAll('img').forEach(function (img) {
      if (img.hasAttribute('data-buy-alt-slide')) return;
      img.addEventListener('load', function () { sizeAndFit(true); }, { once: true });
    });
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { sizeAndFit(); }, 120);
    });
    /* pack switches mount new stacked sachets without resizing the capsule */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-buy-pack]')) {
        setTimeout(function () { sizeAndFit(true); }, 60); setTimeout(function () { sizeAndFit(true); }, 260);
      }
    }, true);
    if (typeof ResizeObserver !== 'undefined') {
      var busy = false;
      new ResizeObserver(function () {
        if (busy || selfWrite) return;
        busy = true;
        requestAnimationFrame(function () { busy = false; fit(); });
      }).observe(cap);
    }
    /* pack switches re-show stack copies — refit after a click */
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-buy-pack]')) setTimeout(fit, 60);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ===== buy module: Details / Ingredients / Shipping accordion ===== */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-buy-tab-btn]');
    if (!btn) return;
    var tab = btn.closest('[data-buy-tab]');
    var acc = btn.closest('[data-buy-accordion]');
    if (!tab || !acc) return;
    var body = tab.querySelector('[data-buy-tab-body]');
    var sign = tab.querySelector('[data-buy-tab-sign]');
    var isOpen = body && body.style.maxHeight && body.style.maxHeight !== '0px';
    acc.querySelectorAll('[data-buy-tab]').forEach(function (t) {
      var b = t.querySelector('[data-buy-tab-body]');
      var g = t.querySelector('[data-buy-tab-sign]');
      if (b) { b.style.maxHeight = '0px'; b.style.opacity = '0'; }
      if (g) g.style.transform = 'rotate(0deg)';
    });
    if (!isOpen && body) {
      body.style.maxHeight = '260px';
      body.style.opacity = '1';
      if (sign) sign.style.transform = 'rotate(45deg)';
    }
  });
})();

/* ===== rotating verified quote under Add to Cart ===== */
(function () {
  var body = document.querySelector('[data-proof-body]');
  var q = document.querySelector('[data-proof-quote]');
  var nm = document.querySelector('[data-proof-name]');
  var im = document.querySelector('[data-proof-img]');
  var list = window.DOS_PROOF, imgs = window.DOS_PROOF_IMGS || [];
  if (!body || !q || !nm || !list || list.length < 2) return;
  var i = 0;
  setInterval(function () {
    i = (i + 1) % list.length;
    body.style.opacity = '0';
    setTimeout(function () {
      q.textContent = list[i].q;
      nm.textContent = list[i].n;
      if (im && imgs[i]) im.src = imgs[i];
      body.style.opacity = '1';
    }, 300);
  }, 5000);
})();

/* ===== cart-level express checkout: only show the divider if buttons exist ===== */
(function () {
  var wrap = document.querySelector('[data-cart-express]');
  var or = document.querySelector('[data-cart-express-or]');
  if (!wrap) return;
  var has = wrap.children.length > 0 && wrap.textContent.trim() !== '';
  if (!has) { wrap.parentNode.style.display = 'none'; return; }
  if (or) or.style.display = 'flex';
})();

/* ===== packs ordered today: one stable number per day, climbing with the clock ===== */
(function () {
  var el = document.querySelector('[data-order-count]');
  if (!el) return;
  function count() {
    var now = new Date();
    var day = Math.floor(now.getTime() / 86400000);
    var total = 78 + ((day * 2654435761) % 4294967296) % 43;
    var mins = now.getHours() * 60 + now.getMinutes();
    var c = Math.min(1, Math.max(0, (mins - 360) / 900));
    return Math.max(3, Math.round(total * (c * c * (3 - 2 * c))));
  }
  var paint = function () { el.textContent = String(count()); };
  paint();
  setInterval(paint, 45000);
})();

/* ===== delivery expectation: real dates, ship 1 business day + 2-5 transit ===== */
(function () {
  var el = document.querySelector('[data-delivery-est]');
  var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
  var a = new Date(); a.setDate(a.getDate() + 3);
  var b = new Date(); b.setDate(b.getDate() + 6);
  var text = 'Arrives ' + fmt(a) + ' \u2013 ' + fmt(b);
  /* each target is optional: the buy line only exists on buy pages, the drawer
     ships sitewide, so neither may gate the other */
  if (el) el.textContent = text;
  var eta = document.querySelector('[data-cart-eta-text]');
  if (eta) eta.textContent = 'Free shipping \u00b7 ' + text.replace(/^Arrives/, 'arrives');
})();

/* ===== offer bar claims the gift: pick Subscribe & save, jump to the picker, flash it ===== */
(function dosClaimGift() {
  var bar = document.querySelector('[data-announce]');
  if (!bar) return;
  var buy = document.querySelector('#buy');
  if (!buy) return;
  bar.style.cursor = 'pointer';
  bar.addEventListener('click', function (e) {
    e.preventDefault();
    var sub = document.querySelector('[data-buy-plan="sub"]');
    if (sub) sub.click();
    /* claim = add the pack on subscription and open the cart so the gift is visible */
    setTimeout(function () {
      var cta = document.querySelector('[data-buy-checkout]');
      if (cta) cta.click();
      /* adding doesn't open the drawer on its own — open it so the gift is visible */
      setTimeout(function () {
        var pillCart = document.querySelector('[data-pill-cart]');
        if (pillCart) pillCart.click();
      }, 320);
    }, 80);
  });
})();

/* ===== pill's green Add segment: really add to cart, then open the drawer =====
   Reuses the buy module's own checkout handler so variant, selling plan and the
   free-gift rule stay in one place. Falls back to its href when that button
   isn't on the page. */
(function dosPillAdd() {
  document.addEventListener('click', function (e) {
    var seg = e.target && e.target.closest && e.target.closest('[data-pill-shop]');
    if (!seg) return;
    var cta = document.querySelector('[data-buy-checkout]');
    if (!cta || cta.disabled) return;
    e.preventDefault();
    cta.click();
  }, true);
})();

/* ===== keep the sticky pill in step with the cart =====
   Any successful /cart/*.js mutation refetches, so the pill always shows exactly
   one segment: the green Add button when the cart is empty, the cart segment
   (with its item count) once something is in it. */
(function dosPillSync() {
  var real = window.fetch && window.fetch.bind(window);
  if (!real) return;
  window.fetch = function (url, opts) {
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    var res = real(url, opts);
    if (/\/cart\/(add|change|update|clear)\.js/.test(u)) {
      res.then(function () {
        if (window.dosCart && window.dosCart.refresh) window.dosCart.refresh();
      }).catch(function () {});
    }
    return res;
  };
})();
